import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { themes } from "services/constants";
export const CustomAutoComplete = ({
  dataList,
  selectedValue,
  Icons,
  updateDataFunction,
  rules,
  placeHolder,
  label,
  errorMessage,
  textBoxError,
  disableAction,
  sx,
  disablePortal = true,
  // Optional, for callers that drive the popup (e.g. the top-bar company
  // picker): controlled open state, a ref to the input, an extra input
  // adornment before the popup arrow, and custom option content.
  open,
  onOpen,
  onClose,
  inputRef,
  inputEndAdornment,
  renderOptionContent,
}) => {
  const controlledOpen = open === undefined ? {} : { open, onOpen, onClose };
  return (
    <Autocomplete
      disablePortal={disablePortal}
      id="combo-box"
      {...controlledOpen}
      size="small"
      value={selectedValue}
      options={dataList}
      // getOptionLabel={(option) => option?.label ?? ""}
      InputLabelProps={{ shrink: true }}
      sx={{ width: "100%", ...sx }}
      ListboxProps={{ style: { maxHeight: "150px" } }}
      filterOptions={(options, state) => {
        return options.filter((option) =>
          (option?.displayLabel ?? option?.label)
            ?.toLowerCase()
            .includes(state.inputValue.toLowerCase()),
        );
      }}
      renderOption={(props, option) => {
        const content = option.displayLabel ?? option.label;
        return <li {...props}>{renderOptionContent ? renderOptionContent(option, content) : content}</li>;
      }}
      isOptionEqualToValue={(option, value) => option?.label === value?.label}
      // onInputChange={(event, value) => updateDataFunction(event, value)}
      onChange={(event, value) => updateDataFunction(event, value)}
      disabled={disableAction}
      renderInput={(params) =>
        Icons ? (
          <TextField
            {...params}
            sx={{ background: themes.whiteColor, borderRadius: "10px" }}
            label={label}
            placeholder={placeHolder}
            size="small"
            value={selectedValue}
            rules={rules}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <Icons style={{ margin: "0 8px", color: "#a6a6a6" }} />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            error={textBoxError}
            helperText={errorMessage}
            fullWidth
            disabled={disableAction}
          />
        ) : (
          <TextField
            {...params}
            sx={{
              background: themes.whiteColor,
              width: "100%",
              ...sx,
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            inputRef={inputRef}
            InputProps={
              inputEndAdornment
                ? {
                    ...params.InputProps,
                    // Autocomplete positions its clear/arrow buttons
                    // absolutely and only reserves room for them, so the
                    // extra icon is placed the same way, just left of them.
                    sx: { ...params.InputProps.sx, pr: "92px !important" },
                    endAdornment: (
                      <>
                        <span
                          style={{
                            position: "absolute",
                            right: 66,
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {inputEndAdornment}
                        </span>
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }
                : params.InputProps
            }
            label={label}
            placeholder={placeHolder}
            value={selectedValue}
            validate
            error={textBoxError}
            helperText={errorMessage}
            disabled={disableAction}
            fullWidth
          />
        )
      }
    />
  );
};
